import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdentityService } from '@shared/core/user-identity.service';
import { Resources } from '@shared/model/permissions';
import { Stage } from '@shared/model/stage';
import { StageItemCount } from '@shared/model/stage-item-count';
import { ItemService } from '@shared/services/item.service';
import { StageService } from '@shared/services/stage.service';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-workflow-stages',
  imports: [CommonModule, SharedModule],
  templateUrl: './workflow-stages.component.html',
  styleUrl: './workflow-stages.component.scss'
})
export class WorkflowStagesComponent implements OnInit {
  myStages!: Stage[];
  itemCounts: number[];
  loadingCount: boolean = true;
  hasWorkflowPermission: boolean = false;

  constructor(
    private stageService: StageService,
    private itemService: ItemService,
    private userIdentityService: UserIdentityService,
    private router: Router
  ) {
    this.itemCounts = new Array<number>();
  }

  ngOnInit() {
    this.getMyStages();
    this.hasWorkflowPermission = this.hasPermission(Resources.Workflow);
  }

  getMyStages() {
    this.stageService.getMyStages()
      .subscribe(stages => {
        this.myStages = stages;
        this.getItemCounts();
      });
  }

  navigateToStage(stage: Stage) {
    this.router.navigate(['/inventory/stageitems', stage.id]);
  }

  getItemCounts() {
    this.loadingCount = true;
    this.itemService.getCountsByStage(this.myStages.map(a => a.id))
      .subscribe(a => {
        a.forEach((result: StageItemCount) => this.itemCounts[result.stageId] = result.count);
        this.loadingCount = false;
      });
  }

  gotoWorkflowSettings() {
    this.router.navigate(['/housekeeping/workflow']);
  }

  hasPermission(resource: Resources) {
    const resourceItem = this.userIdentityService.currentPermissionValue?.find(a => a.resource == resource);
    return !!resourceItem;
  }

  getStageShadow(color: string) {
    return this.toRgba(color, 0.18);
  }

  private toRgba(color: string, alpha: number) {
    if (!color) {
      return `rgba(0, 0, 0, ${alpha})`;
    }

    const trimmed = color.trim();
    if (trimmed.startsWith('rgb')) {
      const numbers = trimmed.replace(/rgba?\(|\)|\s/g, '').split(',');
      const r = Number(numbers[0]);
      const g = Number(numbers[1]);
      const b = Number(numbers[2]);
      if ([r, g, b].some(value => Number.isNaN(value))) {
        return `rgba(0, 0, 0, ${alpha})`;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    const hex = trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
    if (hex.length !== 3 && hex.length !== 6) {
      return `rgba(0, 0, 0, ${alpha})`;
    }

    const normalized = hex.length === 3
      ? hex.split('').map((ch) => ch + ch).join('')
      : hex;
    const intVal = parseInt(normalized, 16);
    const r = (intVal >> 16) & 255;
    const g = (intVal >> 8) & 255;
    const b = intVal & 255;

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

}
